import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import SharedNavbar from '../components/SharedNavbar';
import './ChaptersBoardPage.css';

/* ── Photos disponibles ── */
import marwenImg  from '../assets/images/marwen.jpeg';
import leilaImg   from '../assets/images/leila.jpeg';
import kaisImg    from '../assets/images/kais.jpeg';
import mohamedImg from '../assets/images/mohamed.jpeg';
import kamelImg   from '../assets/images/kamel.jpeg';
import jamelImg   from '../assets/images/jamel.jpeg';
import noorImg    from '../assets/images/noor.jpeg';
import chedliImg  from '../assets/images/chedli.jpeg';
import aliImg     from '../assets/images/ali.jpeg';
import faroukImg  from '../assets/images/farouk.png';

const officers = [
  {
    id: 1,
    name: 'Marwen BEN NASR',
    role: 'Founding President',
    expertise: 'Head of Data Office Department – Banque Zitouna Tunisia',
    photo: marwenImg,
    linkedin: 'https://www.linkedin.com/in/marwen-ben-nasr-cbap%C2%AE-pmp%C2%AE-pmi-acp%C2%AE-a84259252/',
    color: '#1B3A6B',
  },
  {
    id: 2,
    name: 'Leila ZAGHDOUD',
    role: 'VP – Communications',
    expertise: 'Director of Financial Risk Management – Banque Zitouna Tunisia',
    photo: leilaImg,
    linkedin: 'https://www.linkedin.com/in/leila-zaghdoud-4aa704140/',
    color: '#0EA5E9',
  },
  {
    id: 3,
    name: 'Kais AMEUR',
    role: 'VP – Governance & Administration',
    expertise: 'Director 4G/5G Planning & Optimization – Tunisie Telecom',
    photo: kaisImg,
    linkedin: 'https://www.linkedin.com/in/kaisameur/',
    color: '#7C3AED',
  },
  {
    id: 4,
    name: 'Farouk MHAMDI',
    role: 'VP – Academic Communication & Educational Partnerships',
    expertise: 'Director, Statistics Department – Higher Institute of Statistics of Tunisia',
    photo: faroukImg,
    description: 'Data science engineer holding a Ph.D. in Applied Mathematics (ENIT, 2017). Engineering degree from ESSAIT (2005) and Master\'s in econometrics from Ecole Polytechnique of Tunis (2006). Currently assistant professor and Director of the Statistics Department at ESSAIT, and researcher at the Signals and Smart Systems Laboratory at ENIT. Research focuses on applied statistics, data science, and time series forecasting.',
    linkedin: 'https://www.linkedin.com/in/farouk-mhamdi-a06327250/',
    color: '#D97706',
  },
  {
    id: 5,
    name: 'Noor BEN MOUGOU',
    role: 'VP – Online Services',
    expertise: 'Project Manager – Ailancy Technology (Paris, France)',
    photo: noorImg,
    description: 'Noor Ben Mougou is a professional with 12 years of experience in project management, business analysis, and product management, with a strong focus on digital transformation and value creation. She stands out through a hybrid positioning at the intersection of business, technology, and data governance, enabling her to effectively structure needs and lead complex initiatives. A founding member of DAMA Tunisia, she serves as Vice President – Online Services, where she actively contributes to the association\'s digital strategy, the implementation and management of online platforms, as well as the development of visibility and engagement within the data community in Tunisia and the Tunisian community in Europe. Her work is part of an international outreach dynamic aimed at connecting talents, fostering knowledge sharing, and promoting best practices in data governance. Her profile combines strategic vision, strong operational execution capabilities, and a deep commitment to the data ecosystem.',
    linkedin: 'https://www.linkedin.com/in/noor-ben-mougou-94774450/',
    color: '#059669',
  },
  {
    id: 6,
    name: 'Mohamed BENZID',
    role: 'VP – Membership, Sponsorship & Volunteers',
    expertise: 'CEO, BE CARTHAI Consulting Tunisia',
    photo: mohamedImg,
    description: 'Mohamed Benzid is a seasoned professional with 20 years of experience in consulting, management, and strategic solution development, with recognized expertise in leading organizations and driving high-value transformation initiatives. He currently serves as CEO of BE CARTHAI Consulting Tunisia, where he leads business development, service structuring, and supports clients in addressing their performance and transformation challenges. In parallel, he holds the position of Vice President – Membership, Sponsorship & Volunteers at DAMA Tunisia, where he plays a key role in community development, strategic partnerships, and volunteer engagement. His contribution actively supports the association\'s growth and strengthens the data ecosystem in Tunisia. He is distinguished by a leadership approach focused on impact, combining strategic vision, operational execution, and strong interpersonal skills. His positioning enables him to bring together diverse stakeholders around shared objectives and to structure complex initiatives in demanding environments. His community engagement is driven by a commitment to strengthening the data community in Tunisia and building bridges with international ecosystems and the Tunisian diaspora, in a spirit of collaboration, knowledge sharing, and collective maturity building.',
    linkedin: 'https://www.linkedin.com/in/mohamed-benzid-605053220/',
    color: '#DB2777',
  },
  {
    id: 7,
    name: 'Kamel LANDOLSI',
    role: 'VP – Marketing',
    expertise: 'Director of Foreign Banking Services & Professional Training Expert – Attijari Bank Tunisia',
    photo: kamelImg,
    description: 'Kamel Landoulsi is a senior professional with 25 years of experience in international banking services, performance management, and professional training development, with recognized expertise in structuring and optimizing high-value financial operations. He currently serves as Director of Foreign Banking Services & Professional Training Expert at Attijari Bank Tunisia, where he plays a strategic role in developing international banking activities and enhancing organizational capabilities. In his role as Vice President – Marketing at DAMA Tunisia, he actively contributes to defining and executing the association\'s marketing strategy, strengthening its visibility, institutional positioning, and overall influence within the data ecosystem in Tunisia and beyond. His work supports the structuring and promotion of initiatives aimed at unifying stakeholders around data governance and information management excellence. His engagement within the data community is driven by a commitment to knowledge sharing, ecosystem development, and international outreach, particularly through strengthening the data community in Tunisia and connecting it with the Tunisian diaspora across Europe, in a spirit of collaboration, knowledge transfer, and ecosystem maturity building.',
    linkedin: 'https://www.linkedin.com/in/kamel-landoulsi-0679273b4/',
    color: '#0891B2',
  },
  {
    id: 8,
    name: 'Chedly BEN SEDRINE',
    role: 'VP – Professional Development',
    expertise: 'Project Manager in Process & Organization, Data Quality Expert (Toulouse, France)',
    photo: chedliImg,
    description: 'Chedli Ben Sedrine is a PMP® certified professional based in Toulouse, Occitanie, France, with 6 years of experience in project management, program delivery, and strategic initiative leadership, with a strong focus on organizational performance and value creation. A founding member of DAMA Tunisia, he serves as Vice President – Professional Development, where he actively contributes to skills development, the structuring of professional growth pathways, and the promotion of best practices in project management and operational excellence. He stands out for a structured and results-oriented approach, combining project management expertise, analytical capabilities, and operational leadership skills, enabling him to effectively lead cross-functional teams and ensure alignment between strategic objectives and execution. His career reflects a continuous commitment to improving practices, upskilling teams, and maximizing value delivered to stakeholders in fast-evolving and performance-driven environments. His work contributes to strengthening the data community in Tunisia as well as the Tunisian diaspora across Europe, fostering engagement, collaboration, and knowledge sharing.',
    linkedin: 'https://www.linkedin.com/in/chedli-ben-sedrine-pmp%C2%AE-a15b42172/',
    color: '#6366F1',
  },
  {
    id: 9,
    name: 'Ali HARBAOUI',
    role: 'VP – Finance & Accounting',
    expertise: 'Accounting Expert – Tunisia',
    photo: aliImg,
    linkedin: 'https://www.linkedin.com/company/dama-tunisia',
    color: '#F59E0B',
  },
  {
    id: 10,
    name: 'Jamel HASNI',
    role: 'VP – Legal Affairs',
    expertise: 'Attorney – Tunisia',
    photo: jamelImg,
    linkedin: 'https://www.linkedin.com/company/dama-tunisia',
    color: '#10B981',
  },
];

const roles = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
          stroke="#1B3A6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      </svg>
    ),
    title: 'Strategic Leadership',
    desc: 'Setting the vision and direction for the DAMA Tunisia chapter.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#1B3A6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="9" cy="7" r="4" stroke="#1B3A6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="#1B3A6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="#1B3A6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'Community Building',
    desc: 'Growing and supporting the local data management community.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="18" height="18" rx="2" stroke="#1B3A6B" strokeWidth="2"/>
        <path d="M8 17V13" stroke="#1B3A6B" strokeWidth="2" strokeLinecap="round"/>
        <path d="M12 17V8" stroke="#1B3A6B" strokeWidth="2" strokeLinecap="round"/>
        <path d="M16 17V11" stroke="#1B3A6B" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    title: 'Education & Standards',
    desc: 'Promoting DMBOK® standards and CDMP® certification across Tunisia.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="#1B3A6B" strokeWidth="2"/>
        <path d="M2 12h20" stroke="#1B3A6B" strokeWidth="2" strokeLinecap="round"/>
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
          stroke="#1B3A6B" strokeWidth="2"/>
      </svg>
    ),
    title: 'International Liaison',
    desc: 'Connecting Tunisia with the global DAMA International network.',
  },
];

const ChaptersBoardPage = () => {
  const [cardsVisible, setCardsVisible] = useState(false);
  const cardsRef = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setCardsVisible(true); obs.disconnect(); } },
      { threshold: 0.10 }
    );
    if (cardsRef.current) obs.observe(cardsRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div className="chapters-page">
      <SharedNavbar />

      {/* ===== HERO ===== */}
      <section className="chapters-hero">
        <div className="chapters-hero-overlay" />
        <div className="chapters-hero-content">
          <h1>Chapter Officers</h1>
          <p>
            Meet the dedicated professionals leading DAMA Tunisia —
            shaping the future of data management across the country.
          </p>
        </div>
      </section>

      {/* ===== INTRO BAND ===== */}
      <section className="chapters-intro-band">
        <div className="chapters-band-inner">
          {roles.map((r, i) => (
            <React.Fragment key={i}>
              <div className="band-item">
                <div className="band-emoji-wrap">
                  {r.icon}
                </div>
                <div className="band-text">
                  <h4>{r.title}</h4>
                  <p>{r.desc}</p>
                </div>
              </div>
              {i < roles.length - 1 && <div className="band-separator" />}
            </React.Fragment>
          ))}
        </div>
      </section>

      {/* ===== OFFICERS GRID ===== */}
      <section className="chapters-officers-section">
        <div className="chapters-container">
          <div className="chapters-section-header">
            <h2>Our Leadership Team</h2>
            <p>
              The Chapter Officers volunteer their time and expertise to advance
              data management practices across Tunisia.
            </p>
          </div>

          <div
            ref={cardsRef}
            className={`officers-grid ${cardsVisible ? 'officers-visible' : ''}`}
          >
            {officers.map((officer, i) => (
              <div
                className="officer-card"
                key={officer.id}
                style={{ '--delay': `${i * 0.10}s`, '--accent': officer.color }}
              >
                <div className="officer-top-bar" />
                <div className="officer-avatar-wrap">
                  <div className="officer-avatar">
                    {officer.photo ? (
                      <img src={officer.photo} alt={officer.name} className="officer-photo" />
                    ) : (
                      <span className="officer-placeholder">👤</span>
                    )}
                  </div>
                </div>
                <div className="officer-info">
                  <h3 className="officer-name-title">{officer.name}</h3>
                  <p className="officer-role">{officer.role}</p>
                  <p className="officer-expertise">{officer.expertise}</p>
                </div>
                <div className="officer-footer">
                  <a
                    href={officer.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    className="officer-linkedin"
                  >
                    <span className="li-box">in</span>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="chapters-cta-section">
        <div className="chapters-container">
          <div className="chapters-cta-grid">
            <Link to="/membership" className="chapters-cta-btn">
              <strong>Become a member</strong>
              <span>Join today and access all our resources</span>
            </Link>
            <Link to="/events" className="chapters-cta-btn">
              <strong>Events</strong>
              <span>Discover upcoming and past events</span>
            </Link>
            <Link to="/about" className="chapters-cta-btn">
              <strong>Sponsor us</strong>
              <span>Connect with the Tunisian data community</span>
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default ChaptersBoardPage;